export type HealthworkerIdentifier = 'star_1' | 'star_2' | 'star_3' | 'star_4';
export type HealthworkerColor = 'red' | 'blue' | 'green' | 'yellow';

export interface HealthworkerStar {
  id: HealthworkerIdentifier;
  color: string;
  colorMuted: string;
  colorName: HealthworkerColor;
  label: string;
}

export const HEALTHWORKER_STARS: HealthworkerStar[] = [
  {
    id: 'star_1',
    color: '#EF4444',
    colorMuted: '#FCA5A5',
    colorName: 'red',
    label: 'Red Star',
  },
  {
    id: 'star_2',
    color: '#3B82F6',
    colorMuted: '#93C5FD',
    colorName: 'blue',
    label: 'Blue Star',
  },
  {
    id: 'star_3',
    color: '#10B981',
    colorMuted: '#6EE7B7',
    colorName: 'green',
    label: 'Green Star',
  },
];

export function getStarById(id: HealthworkerIdentifier): HealthworkerStar {
  return HEALTHWORKER_STARS.find((s) => s.id === id)!;
}

export function getStarByColor(color: HealthworkerColor): HealthworkerStar {
  return HEALTHWORKER_STARS.find((s) => s.colorName === color)!;
}
